import React from 'react';
import { Menu, MenuItem, Link } from '@mui/material';
import { TandemLink, Colors } from 'library';

export default function ResourceMenu({
    isMenuOpen,
    handleMenuClose,
    anchorRef,
}: {
    isMenuOpen: boolean;
    handleMenuClose: () => void;
    anchorRef: React.RefObject<HTMLDivElement> | null;
}) {
    return (
        <Menu
            anchorEl={anchorRef?.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            sx={{
                borderRadius: 18,
            }}
        >
            <MenuItem>
                <TandemLink to="/about-us" onClick={handleMenuClose}>
                    About Us
                </TandemLink>
            </MenuItem>
            <MenuItem>
                <Link
                    href="https://blog.join-tandem.com/"
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                        color: Colors.darkNavy,
                        fontFamily: 'Outfit',
                        fontSize: 14,
                        textDecoration: 'none',
                        '&:hover': {
                            color: '#1A73E8',
                        },
                    }}
                >
                    Community Corner
                </Link>
            </MenuItem>
        </Menu>
    );
}
